import React, { PureComponent } from 'react';
import {CSVLink} from 'react-csv';
import './style.scss';
import TableSort from "../../../../components/table/TableSort";
import { connect } from 'react-redux';
import Loading from '../../../../components/loading';
import { ACTIONS_TEAM, converDataBatters, getListTeamBatters } from '../../../../actions/team-batters';
import {host} from "../../../../environment";


class TeamBatter extends PureComponent {

    constructor(props) {
        super(props);
        this.count = 0;
        this.state = {
            headerCSV: [],
            idTeam: 0,
            showLoading: false,
            listBatters: [],
            listCsv: [],
        }
        this.onRedirect = this.onRedirect.bind(this);
    }

    UNSAFE_componentWillMount() {
        const headerCSV = this.props.header && this.props.header.map((item) => {
            return item.name;
        });
        this.setState({
            headerCSV: headerCSV
        });
        this.setState({ showLoading: true })
        let id = this.props.match.params.id;
        id && this.setState({ idTeam: id });
        this.props.getListTeamBatters(id);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return !(this.count > 1);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            if (nextProps.status === ACTIONS_TEAM.GET_INFO_BATTERS_GAMES_SUCCESS) {
                if(this.count > 1) return;
                this.count += 1;
                const data = converDataBatters(nextProps.response) || [];
                this.setState({
                    listBatters: data,
                    showLoading: false,
                    listCsv: data.map(item => item.item.map(value => {
                        if(value.text === 0) {
                            return 0;
                        }
                        return value.text || '';
                    })),
                });
                if(nextProps.default_sort) {
                    this.props.header.map(item => {
                        item.default_sort = nextProps.default_sort[item.name_s];
                    })
                }

            }
        }
    }

    onRedirect(id) {
        this.props.history.push('/player/' + id);
    }

    render() {
        const sortConfig = {
            url: `${host.serverTest}api/teams/${this.state.idTeam}/batters`,
            type: 'batter'
        };
        return (
            <div className="team-batter">
                <div className="wrapper" id='team-batter'>
                    <div className="block-button">
                        <div className="explain-text">
                            <div>※打率、長打率、出塁率、OPSを選択時：規定打席数を満たしている選手データは</div><div className="orange-text">__</div><div>より上段に表示されます。</div>
                        </div>
                        <CSVLink className={'csv-download'} headers={this.state.headerCSV} data={this.state.listCsv} filename={'team-batter.csv'}>
                            CSVダウンロード
                        </CSVLink>
                    </div>
                    <TableSort
                        isFilterCondition = {true}
                        header={this.props.header}
                        showCheckbox={false}
                        showSearch={false}
                        sort={sortConfig}
                        itemOfPage={this.state.listBatters}
                        isShowOptionTable={false}
                        showPagination={false}
                        defaultValue={'-'}
                        onRowClick={(value) => this.onRedirect(value.id)}
                    />
                </div>
                <Loading show={this.state.showLoading} />
            </div>
        );
    }
}

const mapStateToProps = ({ teamBatters }) => {
    return {
        header: teamBatters.headerBatters,
        response: teamBatters.response,
        status: teamBatters.status,
        default_sort: teamBatters.default_sort
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getListTeamBatters: (id) => {
            dispatch(getListTeamBatters(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(TeamBatter);
